import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { GovIdUploadDataType } from '../../../../models/dashboard/settings/profileSettings/UploadGovId.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
// import { useAppSelector } from '../../../../redux/store'
import useHttps from '../../../useHttps';
import useGetUserData from '../useGetUserData';
import { ModalContext } from '../../../../context/ModalContext';
import { useContext } from 'react';

const useUploadGovId = () => {
  // const { authData } = useAppSelector((state) => state.auth);
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetUserData();

  const onUploadGovIdError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating basic information'
    );
  };

  const modal = useContext(ModalContext);

  const onUploadGovIdSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(message);
    getUserData();
    modal?.displayModal(false);
  };

  const uploadGovId = (data: GovIdUploadDataType) => {
    const formData = new FormData();

    // Append governmentId if provided (assuming it is a File object)
    // Append governmentId if provided and is a File
    if (data.governmentId && data.governmentId instanceof File) {
      formData.append('governmentId', data.governmentId);
    }

    const url: HttpConfig = {
      url: `auth-service/users`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    request(url, onUploadGovIdSuccess, setLoading, onUploadGovIdError);
  };

  return { uploadGovId, loading };
};

export default useUploadGovId;
